import type { Shape } from "@/telestrations/types/canvas";

/**
 * Calculate ellipse or circle update object for shape during drag.
 * If isCircle is true, shape is forced to be a circle.
 * Returns the update object for Shape (x, y, radiusX, radiusY).
 */
export function getEllipseUpdate({
  shape,
  pointer,
  isCircle = false,
  offset = { x: 0, y: 0 },
}: {
  shape: Shape;
  pointer: { x: number; y: number };
  isCircle?: boolean;
  offset?: { x: number; y: number };
}): Partial<Shape> {
  const dx = pointer.x - shape.startX;
  const dy = pointer.y - shape.startY;
  let width = Math.abs(dx);
  let height = Math.abs(dy);
  if (isCircle) {
    const size = Math.max(width, height);
    width = size;
    height = size;
  }
  // Center of ellipse/circle
  const centerX = shape.startX + (dx < 0 ? -width / 2 : width / 2) + offset.x;
  const centerY = shape.startY + (dy < 0 ? -height / 2 : height / 2) + offset.y;
  return {
    x: centerX,
    y: centerY,
    radiusX: width / 2,
    radiusY: height / 2,
  };
}
